import React from 'react';
import { Route, IndexRoute } from 'react-router';
import promiseRetry from 'promise-retry';
import JustGivingLoginEmailPage from '@jg/justgiving-app-login/app/containers/pages/EmailPage';
import JustGivingLoginPasswordPage from '@jg/justgiving-app-login/app/containers/pages/PasswordPage';
import JustGivingLoginRegisterPage from '@jg/justgiving-app-login/app/containers/pages/RegisterPage';
import App from 'layouts/App/App';
import LandingLayout from 'layouts/Landing/Landing';
import CharitySearchLayout from 'layouts/CharitySearch/CharitySearch';
import InviteFriendsLayout from 'layouts/InviteFriends/InviteFriends';
import SummaryPageLayout from 'layouts/SummaryPage/SummaryPage';
import apiActions from 'actions/apiActions/apiActions';
import mainActions from 'actions/mainActions/mainActions';
import LoginLayout from 'layouts/Login/Login';
import ErrorPage from 'layouts/ErrorPage/ErrorPage';
import config from 'config/config';

const createRoutes = (store) => {
  const handleRootOnEnter = (nextState) => {
    const query = nextState.location.query;
    const participantPromise = promiseRetry(
      (retry) => store.dispatch(apiActions.getParticipant(query.guid)).catch(retry),
      {
        retries: 2,
        factor: 1,
        minTimeout: 2000,
        maxTimeout: 3000,
      },
    ).catch(() => {
      store.dispatch(mainActions.updateParticipantRequestError(true));
    });
    store.dispatch(mainActions.saveParticipantPromise(participantPromise));
    if (query.charityId) {
      store.dispatch(mainActions.setCharity(query.charityId));
    }
  };

  return (
    <Route path={config.ROOT_PATH || '/'} component={App} onEnter={handleRootOnEnter}>
      <IndexRoute component={LandingLayout} />
      <Route path="charity-search" component={CharitySearchLayout} />
      <Route path="login" component={LoginLayout} >
        <IndexRoute component={JustGivingLoginEmailPage} />
        <Route path="email" component={JustGivingLoginEmailPage} />
        <Route path="password" component={JustGivingLoginPasswordPage} />
        <Route path="register" component={JustGivingLoginRegisterPage} />
      </Route>
      <Route path="invite-friends" component={InviteFriendsLayout} />
      <Route path="summary" component={SummaryPageLayout} />
      <Route path="*" component={ErrorPage} />
    </Route>
  );
};

export default createRoutes;



// WEBPACK FOOTER //
// ./routes.js